// 🔧 lgv_notification_banner.js
// ✅ Purpose: Standard notification banner for the LGV platform
// ✅ Features:
// - Displays success, error, warning, and info messages
// - Consistent styling across all LGV engines
// - Optional dismiss button
// - Optional auto-hide support (handled by parent page)
// - Fully block-commented for clarity and future devs

import React from "react";

/**
 * LGVNotificationBanner
 *
 * Standard notification banner used across the
 * entire Let's Go Vote platform.
 *
 * The parent page controls:
 * - Visibility
 * - Auto-hide timer
 * - Message
 * - Type
 */
const LGVNotificationBanner = ({
  show = false,
  type = "success",
  message = "",
  onClose = null,
}) => {
  if (!show || !message) {
    return null;
  }

  const alertClass = {
    success: "alert-success",
    error: "alert-danger",
    warning: "alert-warning",
    info: "alert-info",
  }[type] || "alert-info";

  const iconClass = {
    success: "bi bi-check-circle-fill",
    error: "bi bi-exclamation-triangle-fill",
    warning: "bi bi-exclamation-circle-fill",
    info: "bi bi-info-circle-fill",
  }[type] || "bi bi-info-circle-fill";

  return (
    <div
      className={`alert ${alertClass} d-flex justify-content-between align-items-start shadow-sm mb-4`}
      role="alert"
    >
      <div className="d-flex align-items-start">

        <i
          className={`${iconClass} me-3`}
          style={{
            fontSize: "1.25rem",
          }}
        />

        <div>
          {message}
        </div>

      </div>

      {onClose && (
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default LGVNotificationBanner;